module.exports = __webpack_public_path__ + "img/mission-icon.9a19dd5c.svg";